<template>
    <div class="pill"  :class="{'pill-danger': danger, 'pill-happy': happy,}">
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'Pill',
  props: {
    danger: {
      default: false,
    },
    happy: {
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
